<div class="language-select" [class.mt-12]="showLabel" [class.dropdown-mode]="mode === 'dropdown'">
  @if (showLabel) {
    <label for="language" class="form-label small-font mb-4">Lingua / Language</label>
  }

  @if (mode === 'inline') {
    <div class="d-flex align-items-center gap-8">
      <button type="button" class="flag-btn" [class.active]="activeLang==='it'" (click)="onLanguageChange('it')" aria-label="Italiano" title="Italiano">
        <img src="assets/images/icons/flags/it.svg" alt="Italiano" />
      </button>
      <button type="button" class="flag-btn" [class.active]="activeLang==='en'" (click)="onLanguageChange('en')" aria-label="English" title="English">
        <img src="assets/images/icons/flags/gb.svg" alt="English" />
      </button>
      <!-- <button type="button" class="flag-btn" [class.active]="activeLang==='fr'" (click)="onLanguageChange('fr')" aria-label="Français" title="Français">
        <img src="assets/images/icons/flags/fr.svg" alt="Français" />
      </button> -->
      <select id="language" class="form-select form-select-sm ms-8 w-auto visually-hidden" [value]="activeLang" (change)="onLanguageChange($any($event.target).value)">
        <option value="it">Italiano</option>
        <option value="en">English</option>
        <!-- <option value="fr">Français</option> -->
      </select>
    </div>
  } @else {
    <!-- dropdown mode -->
    <div ngbDropdown [placement]="menuAlign === 'end' ? 'bottom-end' : 'bottom-start'">
      <button ngbDropdownToggle type="button" class="flag-btn dropdown-toggle" [attr.aria-label]="activeFlagAlt" title="{{ activeFlagAlt }}">
        <img [src]="activeFlagSrc" [alt]="activeFlagAlt" title="{{ activeFlagAlt }}" />
        <span class="visually-hidden">{{ activeFlagAlt }}</span>
      </button>
      <div ngbDropdownMenu [class.dropdown-menu-end]="menuAlign === 'end'">
        <button ngbDropdownItem type="button" (click)="onLanguageChange('it')" [class.active]="activeLang==='it'">
          <img src="assets/images/icons/flags/it.svg" alt="Italiano" />
          <span class="ms-2">Italiano</span>
        </button>
        <button ngbDropdownItem type="button" (click)="onLanguageChange('en')" [class.active]="activeLang==='en'">
          <img src="assets/images/icons/flags/gb.svg" alt="English" />
          <span class="ms-2">English</span>
        </button>
        <!-- <button ngbDropdownItem type="button" (click)="onLanguageChange('fr')" [class.active]="activeLang==='fr'">
          <img src="assets/images/icons/flags/fr.svg" alt="Français" />
          <span class="ms-2">Français</span>
        </button> -->
      </div>
    </div>
  }
</div>
